"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailOverviewPeriodEnum = void 0;
var MailOverviewPeriodEnum;
(function (MailOverviewPeriodEnum) {
    MailOverviewPeriodEnum["Disabled"] = "disabled";
    MailOverviewPeriodEnum["Weekly"] = "weekly";
    MailOverviewPeriodEnum["Monthly"] = "monthly";
})(MailOverviewPeriodEnum = exports.MailOverviewPeriodEnum || (exports.MailOverviewPeriodEnum = {}));
//# sourceMappingURL=mail-overview-period-enum.js.map